import { Component, ChangeDetectionStrategy, Input, Injector, inject } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TuiDialogService } from '@taiga-ui/core';
import { PolymorpheusComponent } from '@taiga-ui/polymorpheus';
import { MessageContentUnion } from '@airgram/core/types/outputs';
import { MessagePhoto } from '@airgram/web';
import { DialogImageViewingComponent } from '@src/app/shared/dialogs';
import { FileReaderService } from '@src/core/services';
import { MultimediaSource } from '@src/models';
import { BaseResizableComponent } from '@src/app/modules/base';

@Component({
  selector: 'app-message-photo',
  templateUrl: './message-photo.component.html',
  styleUrls: ['../styles/message-content.scss', './message-photo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessagePhotoComponent extends BaseResizableComponent {
  private readonly fileReaderService = inject(FileReaderService);
  private readonly dialogService = inject(TuiDialogService);
  private readonly injector = inject(Injector);

  @Input() set message(mess: MessageContentUnion | undefined) {
    this.messagePhoto = mess as MessagePhoto;
  }

  messagePhoto?: MessagePhoto;
  messagePhotoSource?: MultimediaSource;

  override ngOnInit(): void {
    super.ngOnInit();

    this.initPhoto();
  }

  viewImage() {
    const bigPhoto =
      this.messagePhoto?.photo?.sizes[2]?.photo ??
      this.messagePhoto?.photo?.sizes[1]?.photo ??
      this.messagePhoto?.photo?.sizes[0]?.photo;
    if (bigPhoto) {
      this.fileReaderService
        .getFilePart(bigPhoto)
        .pipe(takeUntil(this.destroyed$$))
        .subscribe(filePart => {
          const bigPhotoSrc = this.fileReaderService.getFileSource(filePart);
          // TODO: replace to TuiPreviewModule
          lastValueFrom(
            this.dialogService.open<boolean>(new PolymorpheusComponent(DialogImageViewingComponent, this.injector), {
              size: 'l',
              data: bigPhotoSrc,
            }),
          );
        });
    }
  }

  private initPhoto(): void {
    if (!this.messagePhoto) return;

    const photo = this.messagePhoto.photo?.sizes[1]?.photo ?? this.messagePhoto.photo?.sizes[0]?.photo;
    if (photo) {
      this.fileReaderService
        .getFilePart(photo)
        .pipe(takeUntil(this.destroyed$$))
        .subscribe(filePart => {
          this.messagePhotoSource = { src: this.fileReaderService.getFileSource(filePart) };
          this.cdr.markForCheck();
        });
    }
  }
}
